// extracted by mini-css-extract-plugin
export var actionButton = "_q8-0";
export var actionMenuContainer = "_q8-i";
export var bubble = "_q8-2";
export var bubbleActionMenu = "_q8-j";
export var bubbleContext = "_q8-6";
export var bubbleItems = "_q8-7";
export var customer = "_q8-3";
export var divider = "_q8-8";
export var fileList = "_q8-9";
export var hiddenComment = "_q8-o";
export var infoAbove = "_q8-a";
export var internal = "_q8-4";
export var lightActionButton = "_q8-1";
export var link = "_q8-b";
export var merchant = "_q8-5";
export var message = "_q8-c";
export var profilePicture = "_q8-e";
export var quillToolbarContainer = "_q8-f";
export var senderDate = "_q8-g";
export var senderDateCustomer = "_q8-h";
export var senderName = "_q8-d";
export var time = "_q8-k";
export var uploadedImage = "_q8-l";
export var username = "_q8-m";
export var xsmall = "_q8-n";